import type { SearchPreferences, SearchPreferencesUpdate } from "@searchui-searchforms/shared/user-preferences";

/**
 * Optimistically merges a save-preferences payload back into the cached
 * contract selected for the page. This keeps a bfcache-restored form aligned
 * with its save, even when no refetch occurs.
 */
export function mergePayloadIntoPreferences(
    cached: SearchPreferences | null,
    payload: SearchPreferencesUpdate,
): SearchPreferences | null {
    if (cached === null) return cached;
    return { ...cached, ...payload };
}
